import { ProductTypes } from '@/modules/base/util/constants'
import { SubscriptionType } from '@/redux/ducks/subscription/types/details'

type ActiveSubscription = Pick<SubscriptionType, 'typeOfSubscription' | 'isTrial' | 'isTaxAccountant'> & {
  type: string
}

interface OfferedSubscriptionType {
  name: string
}

export const isLegacyPlan = (activeSubscription?: ActiveSubscription, offeredSubscriptionTypes: OfferedSubscriptionType[] = []): boolean => {
  if (!activeSubscription || activeSubscription.isTrial || activeSubscription.isTaxAccountant) return false
  if (activeSubscription.typeOfSubscription !== ProductTypes.MAIN) return false
  if (!offeredSubscriptionTypes.length) return false

  return !offeredSubscriptionTypes.some(({ name }) => name === activeSubscription.type)
}
